import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/utils/store';
import { percentage } from '@/utils/format';
import { useCurrency } from '@/hooks/useCurrency';
import Modal from '@/components/ui/Modal';
import Button from '@/components/ui/Button';

export default function PayInstallmentModal({ open, onClose, credit }) {
  const { t } = useTranslation();
  const { format: formatCurrency } = useCurrency();
  const payInstallment = useStore((s) => s.payInstallment);
  const [createTransaction, setCreateTransaction] = useState(true);

  if (!credit) return null;

  const isCompleted = credit.paidInstallments >= credit.totalInstallments;
  const nextInstallment = credit.paidInstallments + 1;
  const pct = percentage(credit.paidInstallments, credit.totalInstallments);

  const handlePay = () => {
    payInstallment(credit.id, createTransaction);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={t('credits.payInstallment')} footer={
      <Button className="w-full" onClick={handlePay} disabled={isCompleted}>
        {isCompleted ? t('credits.completed') : t('credits.payInstallment')}
      </Button>
    }>
      <div className="space-y-4">
        <div className="text-center">
          <div className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
            {credit.description}
          </div>
          <div className="text-3xl font-bold text-brand-600 dark:text-brand-400">
            {formatCurrency(credit.installmentAmount)}
          </div>
        </div>

        {/* Progress */}
        <div className="bg-gray-50 dark:bg-gray-800 rounded-xl p-4">
          <div className="flex justify-between text-sm mb-2">
            <span className="text-gray-500">
              {t('credits.installmentOf', { current: nextInstallment, total: credit.totalInstallments })}
            </span>
            <span className="font-medium text-gray-900 dark:text-white">{pct}%</span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-3">
            <div
              className="h-3 rounded-full bg-brand-500 transition-all"
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>

        {/* Checkbox */}
        <label className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-xl cursor-pointer">
          <input
            type="checkbox"
            checked={createTransaction}
            onChange={(e) => setCreateTransaction(e.target.checked)}
            className="w-5 h-5 rounded border-gray-300 text-brand-600 focus:ring-brand-500"
          />
          <span className="text-sm text-gray-700 dark:text-gray-300">
            {t('credits.registerAsExpense')}
          </span>
        </label>

      </div>
    </Modal>
  );
}
